// Pastel color palettes for quotes and accesses.
export const QUOTE_COLORS = [
  { key: null, label: "Sin color", bg: "#ffffff", dot: "#e2e8f0" },
  { key: "green", label: "Verde", bg: "#dcfce7", dot: "#86efac" },
  { key: "blue", label: "Azul", bg: "#dbeafe", dot: "#93c5fd" },
  { key: "red", label: "Rojo", bg: "#fee2e2", dot: "#fca5a5" },
  { key: "orange", label: "Naranja", bg: "#ffedd5", dot: "#fdba74" },
];

export const ACCESS_COLORS = [
  { key: null, label: "Sin color", bg: "#ffffff", dot: "#e2e8f0" },
  { key: "slate", label: "Gris", bg: "#f1f5f9", dot: "#cbd5e1" },
  { key: "red", label: "Rojo", bg: "#fee2e2", dot: "#fca5a5" },
  { key: "orange", label: "Naranja", bg: "#ffedd5", dot: "#fdba74" },
  { key: "amber", label: "Ámbar", bg: "#fef3c7", dot: "#fcd34d" },
  { key: "yellow", label: "Amarillo", bg: "#fef9c3", dot: "#fde047" },
  { key: "lime", label: "Lima", bg: "#ecfccb", dot: "#bef264" },
  { key: "green", label: "Verde", bg: "#dcfce7", dot: "#86efac" },
  { key: "teal", label: "Turquesa", bg: "#ccfbf1", dot: "#5eead4" },
  { key: "sky", label: "Cielo", bg: "#e0f2fe", dot: "#7dd3fc" },
  { key: "blue", label: "Azul", bg: "#dbeafe", dot: "#93c5fd" },
  { key: "violet", label: "Violeta", bg: "#ede9fe", dot: "#c4b5fd" },
  { key: "pink", label: "Rosa", bg: "#fce7f3", dot: "#f9a8d4" },
];

export const colorBg = (palette, key) => (palette.find((c) => c.key === key) || palette[0]).bg;

// Sticky-note style palette for the Notes board.
export const NOTE_COLORS = [
  { key: "yellow", label: "Amarillo", bg: "#fef9c3", dot: "#fde047" },
  { key: "green", label: "Verde", bg: "#dcfce7", dot: "#86efac" },
  { key: "blue", label: "Azul", bg: "#dbeafe", dot: "#93c5fd" },
  { key: "pink", label: "Rosa", bg: "#fce7f3", dot: "#f9a8d4" },
  { key: "orange", label: "Naranja", bg: "#ffedd5", dot: "#fdba74" },
  { key: "violet", label: "Violeta", bg: "#ede9fe", dot: "#c4b5fd" },
  { key: "slate", label: "Gris", bg: "#f1f5f9", dot: "#cbd5e1" },
];
